(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tanwa-why-choose"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tanwa-why-carousel')) {
    customElements.define('tanwa-why-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.track = this.querySelector('.tanwa-why-choose__grid');
        this.items = Array.from(this.track.children);
        this.previous = this.querySelector('[data-direction="-1"]');
        this.next = this.querySelector('[data-direction="1"]');
        this.position = this.querySelector('.tanwa-why-choose__position');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.onScroll = () => this.update();
        this.onClick = event => {
          const button = event.target.closest('[data-direction]');
          if (button && this.contains(button)) this.go(this.index + Number(button.dataset.direction));
        };
        this.onKeyDown = event => {
          if (event.target !== this.track || !this.mobile.matches) return;
          const destinations = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.items.length - 1 };
          if (!(event.key in destinations)) return;
          event.preventDefault();
          this.go(destinations[event.key]);
        };
        this.onBreakpoint = () => {
          if (this.mobile.matches) {
            this.track.setAttribute('tabindex', '0');
          } else {
            this.track.removeAttribute('tabindex');
          }
          this.update();
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.addEventListener('click', this.onClick);
        this.track.addEventListener('keydown', this.onKeyDown);
        this.mobile.addEventListener('change', this.onBreakpoint);
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.onBreakpoint();
      }
      update() {
        const step = this.items.length > 1 ? this.items[1].offsetLeft - this.items[0].offsetLeft : this.track.clientWidth;
        this.index = this.mobile.matches && step > 0 ? Math.max(0, Math.min(this.items.length - 1, Math.round(this.track.scrollLeft / step))) : 0;
        const label = `${this.index + 1} of ${this.items.length}`;
        if (this.position.textContent !== label) this.position.textContent = label;
        this.previous.disabled = this.index === 0;
        this.next.disabled = this.index === this.items.length - 1;
      }
      go(index) {
        if (!this.mobile.matches) return;
        const item = this.items[Math.max(0, Math.min(this.items.length - 1, index))];
        if (!item) return;
        this.track.scrollTo({
          left: item.offsetLeft - this.items[0].offsetLeft,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
      disconnectedCallback() {
        if (!this.ready) return;
        this.track.removeEventListener('scroll', this.onScroll);
        this.removeEventListener('click', this.onClick);
        this.track.removeEventListener('keydown', this.onKeyDown);
        this.mobile.removeEventListener('change', this.onBreakpoint);
        this.resizeObserver.disconnect();
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
